import { createFileRoute } from '@tanstack/react-router';
import DetailReportHistory from '@/featured/dashboard/report/detail-report-history';
import ReportNavTabs from '@/featured/dashboard/report/ReportNavTabs';

export default function ReportHistory() {
  return (
    <div className="w-full">
      <ReportNavTabs />
      <DetailReportHistory />
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/dashboard/report/history')({
  component: ReportHistory,
});
